import React, { useState } from "react";
import { CSSTransition } from "react-transition-group";

import CloseIcon from "../assets/lock.png"; // Update the path accordingly

function DropDownSearchBar() {
  const [isNavOpen, setIsNavOpen] = useState(false);

  const toggleNav = () => {
    setIsNavOpen(!isNavOpen);
  };

  return (
    <div className="bg-black text-white h-screen">
      <div className="fixed top-4 left-4">
        <button
          className="bg-transparent border-none p-2 cursor-pointer z-50"
          onClick={toggleNav}
        >
          {isNavOpen ? (
            <img
              src={CloseIcon}
              alt="Close"
              className="w-6 h-6 text-yellow-500"
            />
          ) : (
            <>
              <span className="w-6 h-1 bg-yellow-500 mb-1 block"></span>
              <span className="w-6 h-1 bg-yellow-500 mb-1 block"></span>
              <span className="w-6 h-1 bg-yellow-500 block"></span>
            </>
          )}
        </button>
      </div>

      <CSSTransition
        in={isNavOpen}
        timeout={900} // Set your preferred animation duration
        classNames="nav-menu"
        unmountOnExit
      >
        <div className="fixed top-0 left-0 right-0 bottom-0 bg-pink-700 bg-opacity-90 flex justify-center items-center">
          <img
            src={CloseIcon}
            alt="Close"
            onClick={toggleNav}
            className="w-6 h-6 text-yellow-500"
          />
          <ul className="text-4xl text-white uppercase text-center">
            <li className="my-8">
              <a href="index.html">Home</a>
            </li>
            <li className="my-8">
              <a href="about.html">About</a>
            </li>
            <li className="my-8">
              <a href="projects.html">Projects</a>
            </li>
            <li className="my-8">
              <a href="contact.html">Contact</a>
            </li>
          </ul>
        </div>
      </CSSTransition>
    </div>
  );
}

export default DropDownSearchBar;
